import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles((theme: any) => ({
  // Chips

  chipSm: {
    "& .MuiChip-label": { paddingLeft: 4, paddingRight: 4 },
    "&.MuiChip-root": { height: 16, fontSize: 10 },
  },
  chipSmNoShrink: {
    flexShrink: 0,
    "& .MuiChip-label": { paddingLeft: 4, paddingRight: 4 },
    "&.MuiChip-root": { height: 16, fontSize: 10 },
  },
  chipSmWide: {
    "& .MuiChip-label": { paddingLeft: 6, paddingRight: 6 },
    "&.MuiChip-root": { height: 16, fontSize: 10 },
  },
  chipSmWithMargin: {
    marginTop: "2px !important",
    "& .MuiChip-label": { paddingLeft: 4, paddingRight: 4 },
    "&.MuiChip-root": { height: 16, fontSize: 10 },
  },
  chipMd: {
    "&.MuiChip-root": { height: 18, fontSize: 11 },
  },
  chipMdPriority: {
    flexShrink: 0,
    "&.MuiChip-root": { height: 18, fontSize: 11, minWidth: 60 },
  },
  masterChip: {
    "& .MuiChip-label": { paddingLeft: 6, paddingRight: 6 },
    "&.MuiChip-root": { height: 18, fontSize: "0.7rem" },
  },

  // Table cells

  th: {
    "&.MuiTableCell-root": {
      padding: "4px 10px",
      fontWeight: 700,
      fontSize: "0.68rem",
      textTransform: "uppercase",
      letterSpacing: 0.5,
      color: theme.palette.text.secondary,
      backgroundColor: theme.palette.action.selected,
      whiteSpace: "nowrap",
    },
  },
  td: {
    "&.MuiTableCell-root": {
      padding: "6px 10px",
      fontSize: "0.8125rem",
      verticalAlign: "middle",
    },
  },
  tdMono: {
    "&.MuiTableCell-root": {
      padding: "6px 10px",
      fontSize: "0.8125rem",
      verticalAlign: "middle",
      fontFamily: "monospace",
    },
  },
  tdServiceHeader: {
    "&.MuiTableCell-root": {
      padding: "4px 10px",
      fontWeight: 700,
      fontSize: "0.68rem",
      textTransform: "uppercase",
      letterSpacing: 0.5,
      color: theme.palette.text.secondary,
      backgroundColor: theme.palette.action.hover,
      whiteSpace: "nowrap",
      borderLeft: `2px solid ${theme.palette.divider}`,
    },
  },
  tdCtrlBorderRight: {
    "&.MuiTableCell-root": {
      padding: "6px 10px",
      fontSize: "0.8125rem",
      verticalAlign: "middle",
      borderRight: `1px solid ${theme.palette.divider}`,
    },
  },
  tdCtrlIndoorId: {
    "&.MuiTableCell-root": {
      padding: "6px 10px",
      fontSize: "0.8125rem",
      verticalAlign: "middle",
      fontFamily: "monospace",
      borderRight: `2px solid ${theme.palette.divider}`,
    },
  },
  tdDividerLeft: {
    "&.MuiTableCell-root": {
      padding: "6px 10px",
      fontSize: "0.8125rem",
      verticalAlign: "middle",
      borderLeft: `2px solid ${theme.palette.divider}`,
    },
  },
  tdSystemLabel: {
    "&.MuiTableCell-root": {
      padding: "6px 10px",
      fontSize: "0.72rem",
      verticalAlign: "middle",
      color: theme.palette.text.secondary,
      fontStyle: "italic",
    },
  },
  tdSystemValue: {
    "&.MuiTableCell-root": {
      padding: "6px 10px",
      fontSize: "0.8125rem",
      verticalAlign: "middle",
      fontFamily: "monospace",
      fontWeight: 600,
    },
  },

  // Table rows

  rowChanged: {
    backgroundColor: "rgba(76,175,80,0.07)",
  },
  rowDisconnected: {
    backgroundColor: "rgba(244,67,54,0.07)",
  },
  rowWithIssues: {
    backgroundColor: "rgba(244,67,54,0.08)",
  },
  cellWithIssues: {
    backgroundColor: "rgba(244,67,54,0.12) !important",
  },
  rowSystemHeader: {
    backgroundColor: theme.palette.action.hover,
  },

  // Page layout

  pageContainer: {
    padding: theme.spacing(3),
    paddingTop: theme.spacing(1),
    maxWidth: 1200,
  },
  searchRow: {
    display: "flex",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  serialField: {
    width: 280,
  },
  multiDevicePaper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  deviceButtonsBox: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
  },
  errorAlert: {
    marginBottom: theme.spacing(2),
  },
  deviceActionsBox: {
    marginBottom: theme.spacing(2),
  },
  lineStatusAlert: {
    marginBottom: theme.spacing(2),
  },
  modeBarRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  modeButtonsGroup: {
    display: "flex",
    gap: theme.spacing(1),
  },
  rightControlsGroup: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  deviceSerialText: {
    fontFamily: "monospace",
  },
  loadingBox: {
    display: "flex",
    justifyContent: "center",
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  },
  jsonPreview: {
    padding: theme.spacing(2),
    borderRadius: 1,
    border: `1px solid ${theme.palette.divider}`,
    overflow: "auto",
    fontSize: "0.72rem",
    fontFamily: "monospace",
    maxHeight: 640,
    lineHeight: 1.5,
  },

  // Tabs

  tabsBar: {
    marginBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  tabLabel: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },

  // VirtualLineView

  brandFixAlertActions: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
  },
  brandFixErrorText: {
    display: "block",
    marginTop: theme.spacing(0.5),
    color: theme.palette.error.main,
    fontSize: "0.8rem",
  },
  changeLogAccordion: {
    marginBottom: theme.spacing(2),
  },
  changeLogDetails: {
    "&.MuiAccordionDetails-root": {
      paddingTop: 0,
    },
  },
  changeLogEntry: {
    paddingTop: 2,
    paddingBottom: 2,
    fontFamily: "monospace",
  },
  unassignedPaper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
    border: `1px dashed ${theme.palette.divider}`,
  },

  // SystemCard

  systemCard: {
    marginBottom: theme.spacing(2),
  },
  systemCardDefault: {
    border: `1px solid ${theme.palette.divider}`,
  },
  systemCardVirtual: {
    border: `2px solid ${theme.palette.warning.main}`,
  },
  systemCardChanged: {
    border: `2px solid ${theme.palette.success.main}`,
  },
  systemHeaderBox: {
    padding: "16px 16px 8px",
  },
  systemHeaderBoxChanged: {
    backgroundColor: "rgba(76,175,80,0.04)",
  },
  systemHeaderFlex: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },
  systemBodyBox: {
    padding: "12px 16px",
  },
  updatedChip: {
    marginLeft: "auto !important",
  },

  // UnitNameAddr

  unitNameAddrBox: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    flexWrap: "nowrap",
    minWidth: 0,
  },
  unitChangedDot: {
    width: 7,
    height: 7,
    borderRadius: "50%",
    backgroundColor: theme.palette.success.main,
    flexShrink: 0,
    display: "inline-block",
  },
  unitNameSpan: {
    maxWidth: 130,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    flexShrink: 1,
    fontWeight: 600,
  },
  unitAddressSpan: {
    fontFamily: "monospace",
    color: theme.palette.text.secondary,
    flexShrink: 0,
    fontSize: "0.8rem",
  },

  // OutdoorTable

  outdoorTableBox: {
    marginBottom: theme.spacing(1.5),
  },
  sectionLabel: {
    textTransform: "uppercase",
    letterSpacing: 0.5,
    display: "block",
    marginBottom: theme.spacing(0.5),
  },
  tableAuto: {
    tableLayout: "auto",
  },

  // ControlServiceTable

  unlinkedServicesBox: {
    marginTop: theme.spacing(2),
  },
  unlinkedServicesLabel: {
    textTransform: "uppercase",
    letterSpacing: 0.5,
    display: "block",
    marginBottom: theme.spacing(0.5),
  },

  // UnitGroup

  unitGroupBox: {
    marginBottom: theme.spacing(1.5),
  },
  unitGroupLabel: {
    textTransform: "uppercase",
    letterSpacing: 0.8,
    display: "block",
    marginBottom: theme.spacing(0.5),
  },
  unitGroupRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    paddingLeft: theme.spacing(1),
    paddingTop: 2,
    paddingBottom: 2,
    flexWrap: "wrap",
  },
  unitGroupName: {
    minWidth: 80,
    maxWidth: 160,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  unitGroupAddr: {
    fontFamily: "monospace",
    fontWeight: 600,
    minWidth: 44,
    color: theme.palette.text.secondary,
  },

  // EntitySection

  entitySectionAccordion: {
    marginBottom: theme.spacing(1),
  },
  entitySectionSummaryBox: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    width: "100%",
    paddingRight: theme.spacing(1),
  },
  entitySectionTitle: {
    flex: 1,
  },
  entitySectionDetails: {
    "&.MuiAccordionDetails-root": {
      padding: 0,
    },
  },

  // EntityRow

  entityRowBox: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  entityRowClean: {
    backgroundColor: theme.palette.action.hover,
  },
  entityRowHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  entityRowHeaderWithIssues: {
    marginBottom: theme.spacing(0.75),
  },
  entityRowSysNumText: {
    fontFamily: "monospace",
  },
  checkIcon: {
    fontSize: "18px !important",
    color: `${theme.palette.success.main} !important`,
    marginLeft: "auto !important",
    flexShrink: "0 !important",
  },
  entityIssueRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1),
    marginTop: theme.spacing(0.5),
  },

  summaryCaption: {
    marginBottom: theme.spacing(2),
    display: "block",
  },
  airnetDefault: {
    color: theme.palette.text.disabled,
    fontStyle: "italic",
  },
  monoText: {
    fontFamily: "monospace",
  },

  // CustomerReportsTab

  filterRow: {
    display: "flex",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(3),
    alignItems: "center",
  },
  unitCountBar: {
    display: "flex",
    gap: theme.spacing(2.5),
    padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
    backgroundColor: theme.palette.action.hover,
    borderRadius: theme.shape.borderRadius,
    flexWrap: "wrap",
    marginBottom: theme.spacing(1.5),
  },
  unitCountItem: {
    display: "flex",
    alignItems: "baseline",
    gap: theme.spacing(0.5),
  },
  diffTableContainer: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  diffTableSymbolCell: {
    "&.MuiTableCell-root": {
      width: 20,
      padding: "5px 8px",
      fontWeight: 700,
      fontSize: "0.85rem",
      textAlign: "center",
      whiteSpace: "nowrap",
    },
  },
  issueGroupsContainer: {
    marginBottom: theme.spacing(1.5),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  issueGroupSectionRow: {
    cursor: "pointer",
    backgroundColor: theme.palette.action.selected,
    "&:hover": { filter: "brightness(0.97)" },
  },
  issueGroupSectionCell: {
    "&.MuiTableCell-root": {
      padding: "5px 12px 5px 8px",
      fontWeight: 700,
      fontSize: "0.75rem",
      color: theme.palette.text.secondary,
    },
  },
  issueGroupItemDesc: {
    "&.MuiTableCell-root": {
      padding: "6px 10px 6px 28px",
      fontSize: "0.82rem",
    },
  },
  issueGroupItemCount: {
    "&.MuiTableCell-root": {
      width: 52,
      padding: "6px 12px",
      fontSize: "0.82rem",
      fontWeight: 700,
      color: theme.palette.text.secondary,
      whiteSpace: "nowrap",
    },
  },
  tableHeaderCell: {
    "&.MuiTableCell-root": {
      padding: "5px 12px",
      fontWeight: 700,
      fontSize: "0.72rem",
      color: theme.palette.text.secondary,
      backgroundColor: theme.palette.action.hover,
    },
  },
  deviceCard: {
    marginBottom: theme.spacing(1.5),
    padding: `${theme.spacing(1.25)} ${theme.spacing(1.5)}`,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  deviceCardHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    marginBottom: theme.spacing(0.75),
  },
  dialogTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },
  sectionLabelCaption: {
    display: "block",
    fontSize: "0.68rem",
    fontWeight: 700,
    color: theme.palette.text.disabled,
    letterSpacing: "0.07em",
    textTransform: "uppercase",
    marginBottom: theme.spacing(0.75),
  },
  diffUnitLabelWrap: {
    display: "inline-flex",
    alignItems: "baseline",
    gap: theme.spacing(0.5),
  },
  statusChipRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    flexWrap: "wrap",
  },
}));

export default useStyles;
